/**
 * VenueData.ts
 * Static list of TAB Venues latitude and longitude
 * Refer to the wiki: https://rwwa.atlassian.net/wiki/spaces/FR/pages/2879717421/Venue+Mode+csv+to+ts+converter
 * on how to generate array from a csv.
 * Refer to: https://rwwa.atlassian.net/wiki/spaces/FR/pages/2460319784/Customer+Location+Geo+Location
 * for more detailed information on data sources
 * */

export type VenueServiceType = 'SL1' | 'SL2' | 'SL3' | 'SL4' | 'SL5' | 'N/A'

export interface Venue {
  locationId: number // e.g. 630
  venueId: string // e.g. TAB
  openingType: string // opening type, e.g. 'Pub/Club Tab',
  name: string // e.g. "The Crown Casino"
  address: string
  latitude: number
  longitude: number
  radius: number
  serviceType: VenueServiceType // agency type, e.g. SL1/2/3/On-Course
}

export const venueData: Venue[] = [
  {
    locationId: 1,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Perth',
    address: '120 Barrack Street, PERTH WA 6000, Australia',
    latitude: -31.9532,
    longitude: 115.8612,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 2,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Account Contact Centre-GMEE',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.90948,
    longitude: 115.806544,
    radius: -1,
    serviceType: 'N/A',
  },
  {
    locationId: 5,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Mt Hawthorn',
    address: '118 Hobart Street, MOUNT HAWTHORN WA 6016, Australia',
    latitude: -31.9218,
    longitude: 115.8405,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 6,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.90948,
    longitude: 115.806544,
    radius: 30,
    serviceType: 'SL1',
  },
  {
    locationId: 8,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Northbridge',
    address: 'Unit 1 129 James Street, NORTHBRIDGE WA 6003, Australia',
    latitude: -31.9483,
    longitude: 115.8574,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 9,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Perth',
    address: '860 Hay Street, PERTH WA 6000, Australia',
    latitude: -31.9524,
    longitude: 115.8538,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 10,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Workshop Qa',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.90948,
    longitude: 115.806544,
    radius: -1,
    serviceType: 'SL1',
  },
  {
    locationId: 11,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wembley Hotel',
    address: '344 Cambridge Street, WEMBLEY WA 6014, Australia',
    latitude: -31.9405,
    longitude: 115.81,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 12,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'White Sands Tavern',
    address: '240 West Coast Highway, SCARBOROUGH WA 6019, Australia',
    latitude: -31.8963,
    longitude: 115.7589,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 13,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Innaloo',
    address: '2 Morris Road, INNALOO WA 6018, Australia',
    latitude: -31.8893,
    longitude: 115.793,
    radius: 40,
    serviceType: 'SL1',
  },
  {
    locationId: 14,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Osborne Park',
    address: '216 Main Street, OSBORNE PARK WA 6017, Australia',
    latitude: -31.897,
    longitude: 115.8288,
    radius: 40,
    serviceType: 'SL1',
  },
  {
    locationId: 15,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Hyde Park Hotel',
    address: '331 Bulwer Street, WEST PERTH WA 6005, Australia',
    latitude: -31.9382,
    longitude: 115.857,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 16,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Malaga',
    address: 'Unit 3 9 Bonner Drive, MALAGA WA 6090, Australia',
    latitude: -31.8505,
    longitude: 115.8784,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 22,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Fremantle',
    address: 'Unit Shop 10 17-23 Collie Street, FREMANTLE WA 6160, Australia',
    latitude: -32.0562,
    longitude: 115.7471,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 23,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Greenwood Hotel',
    address: '349 Warwick Road, GREENWOOD WA 6024, Australia',
    latitude: -31.8331,
    longitude: 115.8032,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 24,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Yokine',
    address: 'Unit T22/22A 6 Wanneroo Road, YOKINE WA 6060, Australia',
    latitude: -31.9107,
    longitude: 115.8476,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 25,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Balcatta',
    address: '501 Wanneroo Road, BALCATTA WA 6021, Australia',
    latitude: -31.8618,
    longitude: 115.8264,
    radius: 30,
    serviceType: 'SL1',
  },
  {
    locationId: 30,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Palmyra',
    address: 'Unit Shop 9 265 Canning Highway, PALMYRA WA 6157, Australia',
    latitude: -32.0387,
    longitude: 115.7763,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 33,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Spearwood',
    address: '6-Feb Lancaster Street, SPEARWOOD WA 6163, Australia',
    latitude: -32.095,
    longitude: 115.7833,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 36,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Maylands',
    address: '223 Railway Parade, MAYLANDS WA 6051, Australia',
    latitude: -31.9275,
    longitude: 115.8916,
    radius: 30,
    serviceType: 'SL1',
  },
  {
    locationId: 37,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Cannington',
    address: '1382 Albany Highway, CANNINGTON WA 6107, Australia',
    latitude: -32.0183,
    longitude: 115.9358,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 39,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: "Franklin's Tavern",
    address: '948 Albany Highway, EAST VICTORIA PARK WA 6101, Australia',
    latitude: -31.9892,
    longitude: 115.9069,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 41,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Belmont',
    address: '174 Wright Street, CLOVERDALE WA 6105, Australia',
    latitude: -31.966486,
    longitude: 115.931549,
    radius: 30,
    serviceType: 'SL1',
  },
  {
    locationId: 42,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Carlisle',
    address: '174 Rutland Avenue, CARLISLE WA 6101, Australia',
    latitude: -31.9797,
    longitude: 115.9108,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 43,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Bentley',
    address: 'Tate Street, BENTLEY WA 6102, Australia',
    latitude: -31.9998,
    longitude: 115.9183,
    radius: 35,
    serviceType: 'SL1',
  },
  {
    locationId: 44,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Queens Park',
    address: '156 Railway Parade, QUEENS PARK WA 6107, Australia',
    latitude: -32.0072,
    longitude: 115.9392,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 45,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Waterford',
    address: '230 Manning Road, WATERFORD WA 6152, Australia',
    latitude: -32.0119,
    longitude: 115.886,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 48,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Como Hotel',
    address: '241 Canning Highway, COMO WA 6152, Australia',
    latitude: -31.9883,
    longitude: 115.8707,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 50,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'South Perth',
    address: 'Unit Shop 1A 25 Mends Street, SOUTH PERTH WA 6151, Australia',
    latitude: -31.9723,
    longitude: 115.8525,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 52,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Kwinana',
    address: 'Unit P2-1 4 Chisham Avenue, KWINANA TOWN CENTRE WA 6167, Australia',
    latitude: -32.2442,
    longitude: 115.8141,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 55,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Girrawheen',
    address: '55 Templeton Crescent, GIRRAWHEEN WA 6064, Australia',
    latitude: -31.837297,
    longitude: 115.830164,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 56,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Booragoon',
    address: '125 Riseley Street, BOORAGOON WA 6154, Australia',
    latitude: -32.0354,
    longitude: 115.8375,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 60,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Warwick',
    address: 'Unit Shop FS004 Beach Road, WARWICK WA 6024, Australia',
    latitude: -31.8451,
    longitude: 115.8102,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 61,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Peppermint Grove',
    address: 'Unit Shop 2 484 Stirling Highway, PEPPERMINT GROVE WA 6011, Australia',
    latitude: -31.9991,
    longitude: 115.7625,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 62,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Dianella',
    address: '162 Alexander Drive, DIANELLA WA 6059, Australia',
    latitude: -31.8946,
    longitude: 115.8709,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 65,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Morley',
    address: '250 Walter Road, MORLEY WA 6062, Australia',
    latitude: -31.8953,
    longitude: 115.897,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 66,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Midland',
    address: '30 Helena Street, MIDLAND WA 6056, Australia',
    latitude: -31.8905,
    longitude: 116.003,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 67,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Bayswater Hotel',
    address: '78-80 Railway Parade, BAYSWATER WA 6053, Australia',
    latitude: -31.9173,
    longitude: 115.9129,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 71,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Hillarys',
    address: 'Unit Shop 69 Whitfords Avenue, HILLARYS WA 6025, Australia',
    latitude: -31.7961,
    longitude: 115.7505,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 73,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Beeches Tavern',
    address: '165 Altone Road, BEECHBORO WA 6063, Australia',
    latitude: -31.8697,
    longitude: 115.9452,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 79,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Karratha',
    address: 'Lot 1079 Searipple Road, KARRATHA WA 6714, Australia',
    latitude: -20.7332,
    longitude: 116.8471,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 82,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Armadale',
    address: '8 Commerce Avenue, ARMADALE WA 6112, Australia',
    latitude: -32.1527,
    longitude: 116.0139,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 84,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Mandurah',
    address: '33 Mandurah Terrace, MANDURAH WA 6210, Australia',
    latitude: -32.5328,
    longitude: 115.7199,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 85,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Victoria Park',
    address: 'Unit Unit 2 4 King George Street, VICTORIA PARK WA 6100, Australia',
    latitude: -31.9734,
    longitude: 115.8962,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 87,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Gosnells',
    address: 'Unit Shop 23 2164 Albany Highway, GOSNELLS WA 6110, Australia',
    latitude: -32.0691,
    longitude: 116.0007,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 92,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Bunbury',
    address: 'Unit Unit 5 LOT 65 Sandridge Road, BUNBURY WA 6230, Australia',
    latitude: -33.3366,
    longitude: 115.6633,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 94,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Castle Hotel',
    address: '97 Avon Terrace, YORK WA 6302, Australia',
    latitude: -31.8897,
    longitude: 116.7681,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 101,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Kalgoorlie',
    address: 'Maritana Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7398,
    longitude: 121.4662,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 103,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Broken Hill Hotel',
    address: '21-29 Forrest Street, BOULDER WA 6432, Australia',
    latitude: -30.7853,
    longitude: 121.4885,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 104,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Non Prod: Training Centre',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.90948,
    longitude: 115.806544,
    radius: -1,
    serviceType: 'N/A',
  },
  {
    locationId: 106,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Boulder',
    address: '62 Burt Street, BOULDER WA 6432, Australia',
    latitude: -30.782,
    longitude: 121.4891,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 108,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Geraldton',
    address: '441 Chapman Road, GERALDTON WA 6530, Australia',
    latitude: -28.7361,
    longitude: 114.6247,
    radius: 35,
    serviceType: 'SL1',
  },
  {
    locationId: 109,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Roebuck Bay Hotel',
    address: 'Carnarvon Street, BROOME WA 6725, Australia',
    latitude: -17.955,
    longitude: 122.2435,
    radius: 15,
    serviceType: 'SL2',
  },
  {
    locationId: 110,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Riverton',
    address: '355 High Road, RIVERTON WA 6148, Australia',
    latitude: -32.0392,
    longitude: 115.9067,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 111,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Paraburdoo Inn',
    address: '622 McRae Avenue, PARABURDOO WA 6754, Australia',
    latitude: -23.2037,
    longitude: 117.6721,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 116,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'East Perth',
    address: '50 Bennett Street, EAST PERTH WA 6004, Australia',
    latitude: -31.958,
    longitude: 115.8722,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 120,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Hamilton Hill',
    address: '330 Carrington Street, HAMILTON HILL WA 6163, Australia',
    latitude: -32.0754,
    longitude: 115.7805,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 122,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dongara Hotel Motel',
    address: '12 Moreton Terrace, DONGARA WA 6525, Australia',
    latitude: -29.2518,
    longitude: 114.9337,
    radius: 50,
    serviceType: 'SL2',
  },
  {
    locationId: 125,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mt Henry Tavern',
    address: '27 Manning Road, COMO WA 6152, Australia',
    latitude: -32.0146,
    longitude: 115.8597,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 128,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Albany',
    address: '134 York Street, ALBANY WA 6330, Australia',
    latitude: -35.0263,
    longitude: 117.8839,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 131,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Herdsman Lake Tavern',
    address: '33 Herdsman Parade, WEMBLEY WA 6014, Australia',
    latitude: -31.9271,
    longitude: 115.8154,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 134,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Silver Sands Tavern',
    address: '176 Mandurah Terrace, MANDURAH WA 6210, Australia',
    latitude: -32.5193,
    longitude: 115.7303,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 140,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Manjimup Hotel',
    address: '109 Giblett Street, MANJIMUP WA 6258, Australia',
    latitude: -34.2399,
    longitude: 116.1471,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 150,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mundaring Hotel',
    address: 'Cnr Nichol and Jacoby Street, MUNDARING WA 6073, Australia',
    latitude: -31.9035,
    longitude: 116.166,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 153,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Carnarvon',
    address: 'Unit Shop 6/7 29 Robinson Street, CARNARVON WA 6701, Australia',
    latitude: -24.8836,
    longitude: 113.657,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 154,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Rockingham Park',
    address: '1A Chalgrove Avenue, ROCKINGHAM WA 6168, Australia',
    latitude: -32.2891,
    longitude: 115.741,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 155,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Norseman Hotel',
    address: '90 Roberts Street, NORSEMAN WA 6443, Australia',
    latitude: -32.1989,
    longitude: 121.7807,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 157,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Victoria Hotel',
    address: '119 Throssell Street, COLLIE WA 6225, Australia',
    latitude: -33.3603,
    longitude: 116.153,
    radius: 20,
    serviceType: 'SL3',
  },
  {
    locationId: 161,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Carnarvon Hotel',
    address: '121 Olivia Terrace, CARNARVON WA 6701, Australia',
    latitude: -24.8883,
    longitude: 113.6564,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 163,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: "George & The Drag'n Tavern",
    address: '62 Second Avenue, SHOALWATER WA 6169, Australia',
    latitude: -32.2925,
    longitude: 115.7102,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 164,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Geraldton Hotel',
    address: '19 Gregory Street, GERALDTON WA 6530, Australia',
    latitude: -28.7769,
    longitude: 114.606,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 167,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Willetton',
    address: '71 Pinetree Gully Road, WILLETTON WA 6155, Australia',
    latitude: -32.0584,
    longitude: 115.8816,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 169,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Freemasons Hotel',
    address: '79 Marine Terrace, GERALDTON WA 6530, Australia',
    latitude: -28.7727,
    longitude: 114.6104,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 172,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Port Hedland',
    address: 'Cnr Lukis & Mcgregor Street, PORT HEDLAND WA 6721, Australia',
    latitude: -20.3088,
    longitude: 118.6102,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 173,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Augusta Hotel Motel',
    address: '53 Blackwood Avenue, AUGUSTA WA 6290, Australia',
    latitude: -34.3167,
    longitude: 115.1604,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 176,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Spearwood Tavern',
    address: '432 Rockingham Road, SPEARWOOD WA 6163, Australia',
    latitude: -32.1161,
    longitude: 115.7831,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 178,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Broome',
    address: 'Unit Shop 22 106 Frederick Street, BROOME WA 6725, Australia',
    latitude: -17.9634,
    longitude: 122.2375,
    radius: 50,
    serviceType: 'SL1',
  },
  {
    locationId: 179,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'South Hedland',
    address: '14 Throssell Road, SOUTH HEDLAND WA 6722, Australia',
    latitude: -20.4089,
    longitude: 118.6,
    radius: 40,
    serviceType: 'SL1',
  },
  {
    locationId: 180,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Wanneroo',
    address: 'Unit 4 957 Wanneroo Road, WANNEROO WA 6065, Australia',
    latitude: -31.7518,
    longitude: 115.8026,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 183,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Cobblers Tavern',
    address: '627 Old Coast Road, FALCON WA 6210, Australia',
    latitude: -32.5823,
    longitude: 115.6616,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 185,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Kalbarri Motor Hotel',
    address: '50 Grey Street, KALBARRI WA 6536, Australia',
    latitude: -27.7104,
    longitude: 114.1656,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 186,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mermaid Dampier Hotel',
    address: '5 Neilson Place, DAMPIER WA 6713, Australia',
    latitude: -20.655,
    longitude: 116.714,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 189,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Swan View Tavern',
    address: '305 Morrison Road, SWAN VIEW WA 6056, Australia',
    latitude: -31.8854,
    longitude: 116.0409,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 190,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Mandurah Racecourse',
    address: 'LOT 125 Gordon Road, MANDURAH WA 6210, Australia',
    latitude: -32.5124,
    longitude: 115.7583,
    radius: 150,
    serviceType: 'SL5',
  },
  {
    locationId: 192,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Gloucester Park',
    address: 'Nelson Crescent, EAST PERTH WA 6004, Australia',
    latitude: -31.9568,
    longitude: 115.8809,
    radius: 150,
    serviceType: 'SL5',
  },
  {
    locationId: 194,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Pannawonica Tavern',
    address: 'Pannawonica Drive, PANNAWONICA WA 6716, Australia',
    latitude: -21.6392,
    longitude: 116.3245,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 195,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Crown Perth',
    address: '201 Great Eastern Highway, BURSWOOD WA 6100, Australia',
    latitude: -31.9615,
    longitude: 115.895,
    radius: 200,
    serviceType: 'SL2',
  },
  {
    locationId: 197,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Parks Tavern',
    address: 'Cnr Brittain Rd & Bussell Highway, BUNBURY WA 6230, Australia',
    latitude: -33.3597,
    longitude: 115.6432,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 198,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Chequers Hotel',
    address: '2543 Great Northern Highway, BULLSBROOK WA 6084, Australia',
    latitude: -31.6713,
    longitude: 116.0307,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 202,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Perth',
    address: '47 Walters Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.9532,
    longitude: 115.8611,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 204,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wongan Hills Hotel',
    address: '5 Fenton Place, WONGAN HILLS WA 6603, Australia',
    latitude: -30.8938,
    longitude: 116.7181,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 205,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Jurien Bay Hotel Motel',
    address: '5 White Street, JURIEN BAY WA 6516, Australia',
    latitude: -30.3049,
    longitude: 115.0378,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 206,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Kingsley',
    address: '90 Kingsley Drive, KINGSLEY WA 6026, Australia',
    latitude: -31.8075,
    longitude: 115.7893,
    radius: 35,
    serviceType: 'SL1',
  },
  {
    locationId: 208,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Endeavour Tavern',
    address: '58 Gingin Road, LANCELIN WA 6044, Australia',
    latitude: -31.0128,
    longitude: 115.3287,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 209,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Bunbury Turf Club',
    address: 'Brittain Road, BUNBURY WA 6230, Australia',
    latitude: -33.3583,
    longitude: 115.6429,
    radius: 180,
    serviceType: 'SL5',
  },
  {
    locationId: 210,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'TABtouch Park Cannington',
    address: 'Cnr Albany Highway & Station Street, CANNINGTON WA 6107, Australia',
    latitude: -32.0212,
    longitude: 115.9423,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 211,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Pace Road Tavern',
    address: '23 Pace Road, MEDINA WA 6167, Australia',
    latitude: -32.2351,
    longitude: 115.8067,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 214,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Hotel Kununurra',
    address: '37 Messmate Way, KUNUNURRA WA 6743, Australia',
    latitude: -15.7753,
    longitude: 128.7388,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 216,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Craigie Tavern',
    address: '119 Eddystone Avenue, CRAIGIE WA 6025, Australia',
    latitude: -31.7839,
    longitude: 115.7676,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 217,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Burbridge Tavern',
    address: '38 Koondoola Avenue, KOONDOOLA WA 6064, Australia',
    latitude: -31.8417,
    longitude: 115.8602,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 218,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Alexander Bar & Bistro',
    address: '322 Alexander Drive, BALLAJURA WA 6066, Australia',
    latitude: -31.8269,
    longitude: 115.8774,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 219,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Malaga Tavern',
    address: '338 Victoria Road, MALAGA WA 6090, Australia',
    latitude: -31.8619,
    longitude: 115.8899,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 220,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mundijong Tavern',
    address: '32 Paterson Road, MUNDIJONG WA 6123, Australia',
    latitude: -32.2944,
    longitude: 115.9857,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 221,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Stud Country Tavern',
    address: '4224 South Western Highway, NORTH DANDALUP WA 6207, Australia',
    latitude: -32.5186,
    longitude: 115.9711,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 222,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Odin Tavern',
    address: '51 Erindale Road, BALCATTA WA 6021, Australia',
    latitude: -31.866,
    longitude: 115.808,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 223,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Byford Tavern',
    address: '881 South West Highway, BYFORD WA 6122, Australia',
    latitude: -32.2221,
    longitude: 116.0083,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 226,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Rendezvous Bar & Grill',
    address: '72 Langford Avenue, LANGFORD WA 6147, Australia',
    latitude: -32.0433,
    longitude: 115.942,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 227,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Geraldton Turf Club',
    address: 'Eastward Road, GERALDTON WA 6530, Australia',
    latitude: -28.7768,
    longitude: 114.6391,
    radius: 150,
    serviceType: 'SL5',
  },
  {
    locationId: 228,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Donnybrook Hotel',
    address: '64 South West Highway, DONNYBROOK WA 6239, Australia',
    latitude: -33.5729,
    longitude: 115.8244,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 229,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Australind Tavern',
    address: '41 Old Coast Road, AUSTRALIND WA 6233, Australia',
    latitude: -33.3051,
    longitude: 115.7022,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 232,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Peel Alehouse',
    address: '8 Guava Way, HALLS HEAD WA 6210, Australia',
    latitude: -32.5503,
    longitude: 115.702,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 233,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Attfield 39',
    address: '39 Attfield Street, MADDINGTON WA 6109, Australia',
    latitude: -32.051,
    longitude: 115.9767,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 234,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Gold N Nickel Bar & Bistro',
    address: 'LOT 402 Mainsbridge Street, LEINSTER WA 6437, Australia',
    latitude: -27.9158,
    longitude: 120.6983,
    radius: 50,
    serviceType: 'SL3',
  },
  {
    locationId: 236,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Cervantes Bar & Bistro',
    address: '1 Cadiz Street, CERVANTES WA 6511, Australia',
    latitude: -30.5009,
    longitude: 115.0685,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 237,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Williams',
    address: 'LOT 26 Albany Highway, WILLIAMS WA 6391, Australia',
    latitude: -33.0286,
    longitude: 116.8797,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 238,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Woodvale Tavern',
    address: '143 Trappers Drive, WOODVALE WA 6026, Australia',
    latitude: -31.7832,
    longitude: 115.7882,
    radius: 50,
    serviceType: 'SL2',
  },
  {
    locationId: 240,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Walpole Hotel-Motel',
    address: 'South Coast Highway, WALPOLE WA 6398, Australia',
    latitude: -34.9757,
    longitude: 116.7272,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 244,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Shark Bay Hotel',
    address: '43 Knight Terrace, DENHAM WA 6537, Australia',
    latitude: -25.9277,
    longitude: 113.5341,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 245,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Leeman Country & Sporting Club',
    address: 'Rudduck Street, LEEMAN WA 6514, Australia',
    latitude: -29.9444,
    longitude: 114.9808,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 246,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Pingelly Hotel',
    address: 'Quadrant Street, PINGELLY WA 6308, Australia',
    latitude: -32.5325,
    longitude: 117.0837,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 247,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Sawyers Valley Tavern',
    address: '10860 Great Eastern Highway, SAWYERS VALLEY WA 6074, Australia',
    latitude: -31.904,
    longitude: 116.2049,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 248,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Desert Inn Hotel',
    address: '2 Laver Place, LAVERTON WA 6440, Australia',
    latitude: -28.6255,
    longitude: 122.4054,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 253,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ravenswood Hotel',
    address: 'Lot 65 Lloyd Avenue, RAVENSWOOD WA 6208, Australia',
    latitude: -32.5856,
    longitude: 115.8274,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 258,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Divers Tavern',
    address: '12 Cable Beach Road, BROOME WA 6725, Australia',
    latitude: -17.9348,
    longitude: 122.2136,
    radius: 45,
    serviceType: 'SL2',
  },
  {
    locationId: 260,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: "Scarborough Sportsmen's Club",
    address: '75 Deanmore Road, SCARBOROUGH WA 6019, Australia',
    latitude: -31.8889,
    longitude: 115.7671,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 261,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ocean Beach Hotel',
    address: 'Cnr Marine Pde & Eric Street, COTTESLOE WA 6011, Australia',
    latitude: -31.99,
    longitude: 115.7529,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 263,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Market City Tavern',
    address: '280 Bannister Road, CANNING VALE WA 6155, Australia',
    latitude: -32.0712,
    longitude: 115.8951,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 264,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Pemberton Best Western Hotel',
    address: '66 Brockman Street, PEMBERTON WA 6260, Australia',
    latitude: -34.4444,
    longitude: 116.0359,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 266,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Waroona Hotel',
    address: '16 Fouracre Street, WAROONA WA 6215, Australia',
    latitude: -32.8442,
    longitude: 115.9213,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 269,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Potshot Hotel Resort',
    address: 'Murat Road, EXMOUTH WA 6707, Australia',
    latitude: -21.9287,
    longitude: 114.1257,
    radius: 60,
    serviceType: 'SL2',
  },
  {
    locationId: 270,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Denver City Hotel',
    address: '73 Bayley Street, COOLGARDIE WA 6429, Australia',
    latitude: -30.955,
    longitude: 121.1637,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 272,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Esplanade Hotel',
    address: '30-38 Marine Terrace, BUSSELTON WA 6280, Australia',
    latitude: -33.6467,
    longitude: 115.3451,
    radius: 45,
    serviceType: 'SL2',
  },
  {
    locationId: 273,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Kardinya Tavern',
    address: '17 South Street, KARDINYA WA 6163, Australia',
    latitude: -32.0681,
    longitude: 115.8182,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 276,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Southern River Tavern',
    address: '70 Blanche Street, GOSNELLS WA 6110, Australia',
    latitude: -32.0686,
    longitude: 115.9826,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 277,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Beldon Tavern',
    address: 'Cnr Marmion Ave & Gunter Grove, BELDON WA 6027, Australia',
    latitude: -31.777,
    longitude: 115.7556,
    radius: 20,
    serviceType: 'SL2',
  },
  {
    locationId: 278,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Tavern at the Rocks',
    address: '50 Enterprise Avenue, TWO ROCKS WA 6037, Australia',
    latitude: -31.4961,
    longitude: 115.5845,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 281,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Joondalup',
    address: 'Unit Shop GD T142 Collier Pass, JOONDALUP WA 6027, Australia',
    latitude: -31.7443,
    longitude: 115.765,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 285,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Internet Betting',
    address: 'OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 286,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Yanchep Inn',
    address: 'Yanchep National Park, YANCHEP WA 6035, Australia',
    latitude: -31.5443,
    longitude: 115.6831,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 287,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Albany Harness Racing Club',
    address: '169 Lancaster Road, ALBANY WA 6330, Australia',
    latitude: -34.986,
    longitude: 117.8326,
    radius: 130,
    serviceType: 'SL5',
  },
  {
    locationId: 288,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Southerlys Harbour View Bar',
    address: '60 Point Leander Drive, PORT DENISON WA 6525, Australia',
    latitude: -29.2744,
    longitude: 114.9212,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 290,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Bunbury Trotting Club',
    address: 'Hands Avenue, BUNBURY WA 6230, Australia',
    latitude: -33.3557,
    longitude: 115.655,
    radius: 180,
    serviceType: 'SL5',
  },
  {
    locationId: 291,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Carine',
    address: '493 Beach Road, DUNCRAIG WA 6023, Australia',
    latitude: -31.8452,
    longitude: 115.7875,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 293,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Corrigin Hotel',
    address: '17 Walton Street, CORRIGIN WA 6375, Australia',
    latitude: -32.3306,
    longitude: 117.8738,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 294,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Port Kennedy Tavern',
    address: '379 Warnbro Sound Avenue, PORT KENNEDY WA 6172, Australia',
    latitude: -32.3667,
    longitude: 115.7553,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 295,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Carlisle Hotel',
    address: '174 Rutland Avenue, CARLISLE WA 6101, Australia',
    latitude: -31.9797,
    longitude: 115.9108,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 296,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Tom Price Hotel Motel',
    address: 'Central Road, TOM PRICE WA 6751, Australia',
    latitude: -22.6948,
    longitude: 117.7954,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 297,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Marri Park Tavern',
    address: '34 Marri Park Drive, CASUARINA WA 6167, Australia',
    latitude: -32.2314,
    longitude: 115.8701,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 299,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'South Lake',
    address: 'Unit Shop 3 Lot 101 North Lake Road, SOUTH LAKE WA 6164, Australia',
    latitude: -32.1066,
    longitude: 115.8272,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 300,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Broome Turf Club',
    address: 'Gantheaume Point Road, BROOME WA 6725, Australia',
    latitude: -17.9753,
    longitude: 122.1837,
    radius: 150,
    serviceType: 'SL5',
  },
  {
    locationId: 302,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Scottalian',
    address: '6626 Great Northern Highway, BINDOON WA 6502, Australia',
    latitude: -31.3512,
    longitude: 116.1141,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 305,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Boddington Hotel',
    address: '40-50 Bannister Road, BODDINGTON WA 6390, Australia',
    latitude: -32.8029,
    longitude: 116.4739,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 308,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dalwallinu Hotel Motel',
    address: '19 Johnston Street, DALWALLINU WA 6609, Australia',
    latitude: -30.2779,
    longitude: 116.6621,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 309,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Tav Sports Bar',
    address: '27 Bond Place, KARRATHA WA 6714, Australia',
    latitude: -20.739,
    longitude: 116.8291,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 312,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Sandy Cove Tavern',
    address: '146 South Yunderup Road, SOUTH YUNDERUP WA 6208, Australia',
    latitude: -32.5852,
    longitude: 115.7944,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 314,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Walkabout Hotel',
    address: '944 Great Northern Highway, PORT HEDLAND WA 6721, Australia',
    latitude: -20.3767,
    longitude: 118.635,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 315,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Marvel Loch Hotel',
    address: '17 Lennenberg Street, MARVEL LOCH WA 6426, Australia',
    latitude: -31.4671,
    longitude: 119.487,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 316,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Round the corner',
    address: '44 Belvidere Street, BELMONT WA 6104, Australia',
    latitude: -31.9469,
    longitude: 115.9399,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 317,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Madeley',
    address: 'Shop 2 Cnr Hepburn Ave & Wanneroo Road, MADELEY WA 6065, Australia',
    latitude: -31.817962,
    longitude: 115.822427,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 318,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Thornlie',
    address: 'Unit Shop 10 101 Forest Lakes Drive, THORNLIE WA 6108, Australia',
    latitude: -32.069088,
    longitude: 115.950788,
    radius: 30,
    serviceType: 'SL1',
  },
  {
    locationId: 321,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Mindarie',
    address: 'Unit 1 4 Bergen Way, MINDARIE WA 6030, Australia',
    latitude: -31.677563,
    longitude: 115.711908,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 325,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Lazy Crab',
    address: '21-23 Park Ridge Drive, BOUVARD WA 6211, Australia',
    latitude: -32.6681,
    longitude: 115.6498,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 331,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Piccadilly Hotel',
    address: '164 Piccadilly Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7441,
    longitude: 121.4645,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 332,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Recreation Hotel',
    address: '140 Burt Street, BOULDER WA 6432, Australia',
    latitude: -30.7821,
    longitude: 121.4841,
    radius: 20,
    serviceType: 'SL3',
  },
  {
    locationId: 333,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Gala Tavern',
    address: '75 Cheetham Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7534,
    longitude: 121.4723,
    radius: 20,
    serviceType: 'SL2',
  },
  {
    locationId: 338,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Madora Bay Tavern',
    address: '1 Madora Beach Road, MADORA BAY WA 6210, Australia',
    latitude: -32.4697,
    longitude: 115.748,
    radius: 20,
    serviceType: 'SL2',
  },
  {
    locationId: 339,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Cockburn Bowling & Rec. Club',
    address: '40 Birchley Road, YANGEBUP WA 6164, Australia',
    latitude: -32.127757,
    longitude: 115.80164,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 345,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Redcliffe Tavern',
    address: '431 Great Eastern Highway, REDCLIFFE WA 6104, Australia',
    latitude: -31.9301,
    longitude: 115.9455,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 346,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Corfield Tavern',
    address: '292 Corfield Street, GOSNELLS WA 6110, Australia',
    latitude: -32.0894,
    longitude: 115.9995,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 347,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ravensthorpe Palace Motor Htl',
    address: '28 Morgan Street, RAVENSTHORPE WA 6346, Australia',
    latitude: -33.5819,
    longitude: 120.0467,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 349,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ten Mile Well Tavern',
    address: '1048 Rockingham Road, WATTLEUP WA 6166, Australia',
    latitude: -32.1778,
    longitude: 115.7945,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 350,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 351,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Boyanup Tavern',
    address: '104 Bridge Street, BOYANUP WA 6237, Australia',
    latitude: -33.4809,
    longitude: 115.7315,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 353,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Truscott Memorial Club',
    address: '26 Payne Street, EXMOUTH WA 6707, Australia',
    latitude: -21.9303,
    longitude: 114.1251,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 354,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Beadon Bay Hotel',
    address: '22 Second Avenue, ONSLOW WA 6710, Australia',
    latitude: -21.6399,
    longitude: 115.115,
    radius: 20,
    serviceType: 'SL3',
  },
  {
    locationId: 355,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mighty Quinn',
    address: '112 Wanneroo Road, TUART HILL WA 6060, Australia',
    latitude: -31.9008,
    longitude: 115.8427,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 356,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Leisure Inn Hotel',
    address: '1 Chalgrove Avenue, ROCKINGHAM WA 6168, Australia',
    latitude: -32.289143,
    longitude: 115.741033,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 357,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dunsborough Tavern',
    address: 'Naturaliste Terrace, DUNSBOROUGH WA 6281, Australia',
    latitude: -33.617,
    longitude: 115.1067,
    radius: 35,
    serviceType: 'SL2',
  },
  {
    locationId: 358,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Karridale Tavern',
    address: '12440 Bussell Highway, KARRIDALE WA 6288, Australia',
    latitude: -34.2022,
    longitude: 115.0989,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 359,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Berrigans Bar and Bistro',
    address: '52 Berrigan Drive, SOUTH LAKE WA 6164, Australia',
    latitude: -32.1109,
    longitude: 115.8399,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 360,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Esperance Bay Turf Club',
    address: 'Lot 202 Fisheries Road, ESPERANCE WA 6450, Australia',
    latitude: -33.818,
    longitude: 121.9276,
    radius: 160,
    serviceType: 'SL5',
  },
  {
    locationId: 362,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Carlton Hotel',
    address: '248 Hay Street, EAST PERTH WA 6004, Australia',
    latitude: -31.958,
    longitude: 115.8713,
    radius: 20,
    serviceType: 'SL3',
  },
  {
    locationId: 364,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Account Sales Centre (Call Centre)',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 0,
    serviceType: 'N/A',
  },
  {
    locationId: 365,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Carnarvon Race Club',
    address: 'Massey Bay Road, CARNARVON WA 6701, Australia',
    latitude: -24.9069,
    longitude: 113.6743,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 369,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Newman Hotel Motel',
    address: '1401 Newman Drive, NEWMAN WA 6753, Australia',
    latitude: -23.3578,
    longitude: 119.7284,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 375,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Beaconsfield Hotel',
    address: '73 Wray Avenue, FREMANTLE WA 6160, Australia',
    latitude: -32.0622,
    longitude: 115.7573,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 384,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Doubleview Bowling Club',
    address: '17 Shearn Crescent, DOUBLEVIEW WA 6018, Australia',
    latitude: -31.9015,
    longitude: 115.7787,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 385,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Sixty30 ',
    address: '36 Baltimore Parade, MERRIWA WA 6030, Australia',
    latitude: -31.6708,
    longitude: 115.7158,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 389,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Collie Racecourse',
    address: 'McVee Road, COLLIE WA 6225, Australia',
    latitude: -33.3729,
    longitude: 116.1698,
    radius: 120,
    serviceType: 'SL5',
  },
  {
    locationId: 390,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Gascoyne Junction Race Club',
    address: 'Mullewa Road, GASCOYNE JUNCTION WA 6705, Australia',
    latitude: -25.05774,
    longitude: 115.113522,
    radius: 120,
    serviceType: 'SL5',
  },
  {
    locationId: 392,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Last Chance Tavern',
    address: 'Throssell Road, SOUTH HEDLAND WA 6722, Australia',
    latitude: -20.4089,
    longitude: 118.6001,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 393,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Leopold Hotel',
    address: '326 Canning Highway, BICTON WA 6157, Australia',
    latitude: -32.0359,
    longitude: 115.7849,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 394,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wagin District Club',
    address: 'Tavistock Street, WAGIN WA 6315, Australia',
    latitude: -33.3096,
    longitude: 117.3447,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 396,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Down The Road Bar & Grill',
    address: '77 Walter Road, BASSENDEAN WA 6054, Australia',
    latitude: -31.8951,
    longitude: 115.9446,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 397,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'York Racing',
    address: 'Spencer Brook Road, YORK WA 6302, Australia',
    latitude: -31.8613,
    longitude: 116.7732,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 401,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Belmont Park',
    address: 'Goodwood Parade, RIVERVALE WA 6103, Australia',
    latitude: -31.9471,
    longitude: 115.892,
    radius: 120,
    serviceType: 'SL5',
  },
  {
    locationId: 402,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Nannup Hotel',
    address: '12 Warren Road, NANNUP WA 6275, Australia',
    latitude: -33.9772,
    longitude: 115.7644,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 408,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dianella Tavern',
    address: '302 The Strand, DIANELLA WA 6059, Australia',
    latitude: -31.8978,
    longitude: 115.8807,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 411,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'South Beach Hotel',
    address: '396 South Terrace, SOUTH FREMANTLE WA 6162, Australia',
    latitude: -32.0728,
    longitude: 115.7532,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 412,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Spinifex Hotel',
    address: 'Clarendon Street, DERBY WA 6728, Australia',
    latitude: -17.3036,
    longitude: 123.6265,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 413,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Ascot Racecourse',
    address: '70 Grandstand Road, ASCOT WA 6104, Australia',
    latitude: -31.9374,
    longitude: 115.9231,
    radius: 220,
    serviceType: 'SL5',
  },
  {
    locationId: 414,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Neo Exotica - Ascot',
    address: 'Grandstand Road, ASCOT WA 6104, Australia',
    latitude: 0,
    longitude: 0,
    radius: 0,
    serviceType: 'N/A',
  },
  {
    locationId: 418,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Premier Hotel',
    address: '1 Williams Road, PINJARRA WA 6208, Australia',
    latitude: -32.6277,
    longitude: 115.8783,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 419,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Albany Hotel',
    address: '244 York Street, ALBANY WA 6330, Australia',
    latitude: -35.0228,
    longitude: 117.8836,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 420,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Pier Hotel',
    address: 'The Esplanade, ESPERANCE WA 6450, Australia',
    latitude: -33.8615,
    longitude: 121.8935,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 422,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wellington Hotel',
    address: '36 Victoria Street, BUNBURY WA 6230, Australia',
    latitude: -33.3228,
    longitude: 115.6372,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 423,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Credit Card Deposits',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 426,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Gloucester Park',
    address: 'Nelson Crescent, EAST PERTH WA 6004, Australia',
    latitude: -31.957,
    longitude: 115.8806,
    radius: 150,
    serviceType: 'SL5',
  },
  {
    locationId: 428,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Hanks Bar & Bistro',
    address: 'LOT 504 Ennis Avenue, COOLOONGUP WA 6168, Australia',
    latitude: -32.2961,
    longitude: 115.7633,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 430,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Eaton Bowling And Social Club',
    address: 'Pratt Road, EATON WA 6232, Australia',
    latitude: -33.3135,
    longitude: 115.7057,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 431,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Northside Tavern',
    address: '58 Bates Street, MERREDIN WA 6415, Australia',
    latitude: -31.4773,
    longitude: 118.2781,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 433,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Noble Falls Tavern',
    address: '2672 Toodyay Road, GIDGEGANNUP WA 6083, Australia',
    latitude: -31.7709,
    longitude: 116.2407,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 439,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Maylands Tavern',
    address: 'Unit Shop 1 32 East Street, MAYLANDS WA 6051, Australia',
    latitude: -31.934256,
    longitude: 115.894756,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 440,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Woodbridge Hotel',
    address: '50 East Street, GUILDFORD WA 6055, Australia',
    latitude: -31.8975,
    longitude: 115.9822,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 443,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Charles Hotel',
    address: '509 Charles Street, NORTH PERTH WA 6006, Australia',
    latitude: -31.9168,
    longitude: 115.8479,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 444,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Melville Bowling Club',
    address: '592 Canning Highway, ALFRED COVE WA 6154, Australia',
    latitude: -32.029769,
    longitude: 115.817221,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 445,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Prince Of Wales Hotel',
    address: '41 Stephens Street, BUNBURY WA 6230, Australia',
    latitude: -33.3263,
    longitude: 115.6383,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 449,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Federal Hotel',
    address: '111 Clive Street, KATANNING WA 6317, Australia',
    latitude: -33.6899,
    longitude: 117.5558,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 450,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Boathouse Tavern',
    address: 'Unit Peel S/Centre 40-44 Pinjarra Road, MANDURAH WA 6210, Australia',
    latitude: -32.5342,
    longitude: 115.7222,
    radius: 20,
    serviceType: 'SL2',
  },
  {
    locationId: 451,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Internet Betting',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 454,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Brooklands Tavern',
    address: '7 Holmes Street, SOUTHERN RIVER WA 6110, Australia',
    latitude: -32.0905,
    longitude: 115.9436,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 455,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Canning Vale',
    address: '30-34 Ranford Road, CANNING VALE WA 6155, Australia',
    latitude: -32.087176,
    longitude: 115.917563,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 456,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Goldfield Tattersalls Club Inc',
    address: '80 Egan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7463,
    longitude: 121.4754,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 457,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Eaton Tavern',
    address: '1 Albatross Crescent, EATON WA 6232, Australia',
    latitude: -33.32,
    longitude: 115.7152,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 458,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Northcliffe Hotel',
    address: '17-19 Wheatley Coast Road, NORTHCLIFFE WA 6262, Australia',
    latitude: -34.631,
    longitude: 116.1237,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 464,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Gate Bar & Bistro',
    address: '816 Beeliar Drive, SUCCESS WA 6164, Australia',
    latitude: -32.1317,
    longitude: 115.8547,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 466,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Kalgoorlie-Boulder Racing Club',
    address: 'Meldrum Avenue, KALGOORLIE WA 6430, Australia',
    latitude: -30.7609,
    longitude: 121.465,
    radius: 120,
    serviceType: 'SL5',
  },
  {
    locationId: 467,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Boab Inn',
    address: '98 Loch Street, DERBY WA 6728, Australia',
    latitude: -17.3086,
    longitude: 123.6382,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 470,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Thornlie',
    address: '336 Spencer Road, THORNLIE WA 6108, Australia',
    latitude: -32.0574,
    longitude: 115.9638,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 472,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Morawa Hotel',
    address: 'Solomon Terrace, MORAWA WA 6623, Australia',
    latitude: -29.2104,
    longitude: 116.011,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 477,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: "C Y O'connor Village Pub",
    address: '625 Warton Road, PIARA WATERS WA 6112, Australia',
    latitude: -32.117745,
    longitude: 115.914175,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 481,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mandurah Bowling & Rec Club',
    address: '89 Allnutt Street, MANDURAH WA 6210, Australia',
    latitude: -32.528,
    longitude: 115.7413,
    radius: 50,
    serviceType: 'SL3',
  },
  {
    locationId: 482,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dudley Park Bowling & Rec Club',
    address: '28 Eden Street, DUDLEY PARK WA 6210, Australia',
    latitude: -32.5395,
    longitude: 115.7291,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 484,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wanneroo Tavern',
    address: '18 Dundebar Road, WANNEROO WA 6065, Australia',
    latitude: -31.7512,
    longitude: 115.8043,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 485,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wokalup Tavern',
    address: '67 South West Highway, WOKALUP WA 6221, Australia',
    latitude: -33.1119,
    longitude: 115.8807,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 486,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Last Local',
    address: '507 Nicholson Road, CANNING VALE WA 6155, Australia',
    latitude: -32.0667,
    longitude: 115.9321,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 487,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Chase Bar & Bistro',
    address: '13 Settlers Avenue, BALDIVIS WA 6171, Australia',
    latitude: -32.3329,
    longitude: 115.8137,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 492,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Belmont Sports & Rec Club',
    address: '400 Abernethy Road, CLOVERDALE WA 6105, Australia',
    latitude: -31.9697,
    longitude: 115.943,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 502,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Mosman Park Bowling Club',
    address: '39 Bay View Terrace, MOSMAN PARK WA 6012, Australia',
    latitude: -32.0089,
    longitude: 115.7696,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 503,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Northam Tavern',
    address: '75 Fitzgerald Street, NORTHAM WA 6401, Australia',
    latitude: -31.650589,
    longitude: 116.673801,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 505,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Gingin Hotel',
    address: '5 Jones Street, GINGIN WA 6503, Australia',
    latitude: -31.3509,
    longitude: 115.9041,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 507,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Morley/Noranda Rec Club',
    address: '85 McGilvray Avenue, NORANDA WA 6062, Australia',
    latitude: -31.8782,
    longitude: 115.8943,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 509,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'High Wycombe',
    address: 'Unit Unit 11 530 Kalamunda Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.9356,
    longitude: 116.0051,
    radius: 15,
    serviceType: 'SL1',
  },
  {
    locationId: 513,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Red Sands Tavern',
    address: 'LOT 1982 Newman Drive, NEWMAN WA 6753, Australia',
    latitude: -23.352426,
    longitude: 119.740266,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 515,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Osborne Park Bowling Club',
    address: '31 Park Street, TUART HILL WA 6060, Australia',
    latitude: -31.8943,
    longitude: 115.8318,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 516,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: "Innaloo Sportsmen's Club",
    address: '75 Birdwood Street, INNALOO WA 6018, Australia',
    latitude: -31.887,
    longitude: 115.7936,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 518,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Albies Bar & Bistro',
    address: '117 Queen Street, BUSSELTON WA 6280, Australia',
    latitude: -33.6517,
    longitude: 115.3452,
    radius: 25,
    serviceType: 'SL2',
  },
  {
    locationId: 521,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'High Wycombe Tavern',
    address: '530 Kalamunda Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.9353,
    longitude: 116.0058,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 522,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Champion Lakes Tavern',
    address: '127 Westfield Road, CAMILLO WA 6111, Australia',
    latitude: -32.1189,
    longitude: 116.002,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 524,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Pinjarra Park',
    address: 'Lot 210 Race Course Road, PINJARRA WA 6208, Australia',
    latitude: -32.6316,
    longitude: 115.8851,
    radius: 120,
    serviceType: 'SL5',
  },
  {
    locationId: 525,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Royal Mail Hotel',
    address: '53 Main Street, MEEKATHARRA WA 6642, Australia',
    latitude: -26.5908,
    longitude: 118.497,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 527,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Derby',
    address: '999 Ashley Street, DERBY WA 6728, Australia',
    latitude: -17.319372,
    longitude: 123.642974,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 532,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Brook Bar & Bistro',
    address: '11 Main Street, ELLENBROOK WA 6069, Australia',
    latitude: -31.7819,
    longitude: 115.9674,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 533,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Karratha Sporting & Rec Club',
    address: 'Searipple Road, KARRATHA WA 6714, Australia',
    latitude: -20.727,
    longitude: 116.8624,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 534,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Drakesbrook Hotel-Motel',
    address: '8229 South Western Highway, WAROONA WA 6215, Australia',
    latitude: -32.8359,
    longitude: -32.8359,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 535,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Civic Hotel',
    address: '981 Beaufort Street, INGLEWOOD WA 6052, Australia',
    latitude: -31.9174,
    longitude: 115.8905,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 536,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'BPAY Deposits',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 537,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Kingsway Bar & Bistro',
    address: '213 Kingsway, DARCH WA 6065, Australia',
    latitude: -31.8125,
    longitude: 115.8435,
    radius: 40,
    serviceType: 'SL2',
  },
  {
    locationId: 538,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Mobile Wagering',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 540,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Interactive TV (ITV)',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 541,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'North Beach Bowling Club',
    address: '7 Kitchener Street, NORTH BEACH WA 6020, Australia',
    latitude: -31.8645,
    longitude: 115.7585,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 542,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Expert Bet Services',
    address: '14 Hasler Street, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 543,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'TABOzBet Services',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 544,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'OZBet Page',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
  {
    locationId: 545,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Kellerberrin',
    address: 'Connelly Street, KELLERBERRIN WA 6410, Australia',
    latitude: -31.628258,
    longitude: 117.712001,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 546,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Mount Barker Turf Club',
    address: 'McDonald Avenue, MOUNT BARKER WA 6324, Australia',
    latitude: -34.6206,
    longitude: 117.6542,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 548,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wanneroo Sports & Social Club',
    address: 'Crisafulli Avenue, WANNEROO WA 6065, Australia',
    latitude: -31.7555,
    longitude: 115.802,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 552,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Quinns Rocks',
    address: '17 Tapping Way, QUINNS ROCKS WA 6030, Australia',
    latitude: -31.671,
    longitude: 115.7033,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 553,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ocean View Tavern',
    address: '2310 Wanneroo Road, NOWERGUP WA 6032, Australia',
    latitude: -31.6491,
    longitude: 115.7349,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 554,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Thornlie Bowling Club',
    address: '50-60 Thornlie Avenue, THORNLIE WA 6108, Australia',
    latitude: -32.0499,
    longitude: 115.9656,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 555,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Boab Tavern',
    address: '107 Dundas Road, HIGH WYCOMBE WA 6057, Australia',
    latitude: -31.9402,
    longitude: 115.9913,
    radius: 30,
    serviceType: 'SL2',
  },
  {
    locationId: 556,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Pinjarra Paceway',
    address: '7 Greenlands Road, PINJARRA WA 6208, Australia',
    latitude: -32.6426,
    longitude: 115.8678,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 557,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Pinjarra Paceway',
    address: '7 PACEWAY COURT, PINJARRA WA 6208, Australia',
    latitude: -32.6426,
    longitude: 115.8678,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 561,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Belmont Tavern',
    address: '174 Wright Street, BELMONT WA 6104, Australia',
    latitude: -31.9666,
    longitude: 115.9316,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 562,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Highway Hotel',
    address: 'Cnr Spencer Street & Forrest Avenue, BUNBURY WA 6230, Australia',
    latitude: -33.3361,
    longitude: 115.6407,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 563,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Lakers Tavern',
    address: '119 Murdoch Road, THORNLIE WA 6108, Australia',
    latitude: -32.0691,
    longitude: 115.9517,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 565,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Tambrey Centre',
    address: 'Lot 4227 Tambrey Drive, KARRATHA WA 6714, Australia',
    latitude: -20.7428,
    longitude: 116.804,
    radius: 50,
    serviceType: 'SL3',
  },
  {
    locationId: 569,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Currambine',
    address: 'Unit FS002 1244 Marmion Avenue, CURRAMBINE WA 6028, Australia',
    latitude: -31.739844,
    longitude: 115.738658,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 571,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Bentley',
    address: '1120-1124 Albany Highway, BENTLEY WA 6102, Australia',
    latitude: -31.9998,
    longitude: 115.9182,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 572,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'West Perth',
    address: '1292 Hay Street, WEST PERTH WA 6005, Australia',
    latitude: -31.9477,
    longitude: 115.8398,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 577,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Marmion Angling & Aquatic Club',
    address: 'West Coast Drive, MARMION WA 6020, Australia',
    latitude: -31.8385,
    longitude: 115.7499,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 578,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Carrington Bar & Bistro',
    address: '330 Carrington Street, HAMILTON HILL WA 6163, Australia',
    latitude: -32.0754,
    longitude: 115.7806,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 579,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Burrendah Tavern',
    address: 'Cnr Burrendah Blvd & Pinetree Gully Road, WILLETTON WA 6155, Australia',
    latitude: -32.058,
    longitude: 115.8817,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 581,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Cervantes Country Club Inc',
    address: 'Aragon Street, CERVANTES WA 6511, Australia',
    latitude: -30.499401,
    longitude: 115.070662,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 583,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Albany Racecourse',
    address: '261 Roberts Road, ALBANY WA 6330, Australia',
    latitude: -35.0349,
    longitude: 117.8153,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 584,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Narrogin',
    address: '50 Clayton Street, NARROGIN WA 6312, Australia',
    latitude: -32.930143,
    longitude: 117.172706,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 587,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wavecrest Bar & Bistro',
    address: '279 Hopetoun-Ravensthorpe Road, HOPETOUN WA 6348, Australia',
    latitude: -33.9181,
    longitude: 120.1367,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 588,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Kwinana Local',
    address: '1 Chisham Avenue, KWINANA TOWN CENTRE WA 6167, Australia',
    latitude: -32.2437,
    longitude: 115.8147,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 589,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Caves House Hotel',
    address: '18 Yallingup Beach Road, YALLINGUP WA 6282, Australia',
    latitude: -33.6452,
    longitude: 115.0313,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 590,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Kellerberrin & Districts Club ',
    address: 'Unit Lot 260 Connelly Street, KELLERBERRIN WA 6410, Australia',
    latitude: -31.6279,
    longitude: 117.716,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 592,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Dongara Irwin Race Club',
    address: 'Brennand Road, DONGARA WA 6525, Australia',
    latitude: -29.2439,
    longitude: 114.9252,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 594,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'York Racing',
    address: 'Spencer Brook Road, YORK WA 6302, Australia',
    latitude: -31.8613,
    longitude: 116.7732,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 597,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Kununurra',
    address: 'Racecourse Road, KUNUNURRA WA 6743, Australia',
    latitude: -15.8038,
    longitude: 128.7497,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 603,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Mingenew',
    address: 'Via Midlands Road, MINGENEW WA 6522, Australia',
    latitude: -29.1997,
    longitude: 115.4477,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 604,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Moora',
    address: '62 Padbury Street, MOORA WA 6510, Australia',
    latitude: -30.6247,
    longitude: 115.990092,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 606,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'East Pilbara Race Club',
    address: 'Great Northern Highway, NEWMAN WA 6753, Australia',
    latitude: -23.3447,
    longitude: 119.7469,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 607,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Northam Race Club',
    address: '175 Yilgarn Street, NORTHAM WA 6401, Australia',
    latitude: -31.6399,
    longitude: 116.7,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 610,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Port Hedland Turf Club',
    address: 'McGregor Road, PORT HEDLAND WA 6721, Australia',
    latitude: -20.3096,
    longitude: 118.6124,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 611,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Roebourne',
    address: 'North West Coastal Highway, KARRATHA WA 6714, Australia',
    latitude: -20.7879,
    longitude: 117.1585,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 612,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Williams',
    address: '35 Richmond Street, WILLIAMS WA 6391, Australia',
    latitude: -33.031952,
    longitude: 116.876428,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 613,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Wagin',
    address: 'Ballagin Street, WAGIN WA 6315, Australia',
    latitude: -33.3061,
    longitude: 117.3369,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 616,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Narrogin',
    address: '50 Clayton Road, NARROGIN WA 6312, Australia',
    latitude: -32.930143,
    longitude: 117.172706,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 617,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Northam',
    address: 'Clark Street, NORTHAM WA 6401, Australia',
    latitude: -31.641588,
    longitude: 116.669115,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 618,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Northam',
    address: 'Clark Street, NORTHAM WA 6401, Australia',
    latitude: -31.641588,
    longitude: 116.669115,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 620,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Toodyay Racecourse',
    address: 'Racecourse Road, TOODYAY WA 6566, Australia',
    latitude: -31.573,
    longitude: 116.4636,
    radius: 100,
    serviceType: 'SL5',
  },
  {
    locationId: 621,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Star and Garter Hotel',
    address: '497 Hannan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7548,
    longitude: 121.4648,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 623,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Duke Bar & Bistro',
    address: '2 Innesvale Way, CARRAMAR WA 6031, Australia',
    latitude: -31.7122,
    longitude: 115.79,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 624,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Ashby Bar & Bistro',
    address: '131 Pinjar Road, ASHBY WA 6065, Australia',
    latitude: -31.731,
    longitude: 115.8044,
    radius: 50,
    serviceType: 'SL2',
  },
  {
    locationId: 625,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Newpark Tavern',
    address: '61 Templeton Crescent, GIRRAWHEEN WA 6064, Australia',
    latitude: -31.837,
    longitude: 115.8302,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 626,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Plantagenet Hotel',
    address: '9 Lowood Road, MOUNT BARKER WA 6324, Australia',
    latitude: -34.6254,
    longitude: 117.6613,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 627,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Seven Mile Inn',
    address: '501 Wanneroo Road, BALCATTA WA 6021, Australia',
    latitude: -31.8618,
    longitude: 115.8264,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 630,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Non Prod: Osborne Park',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: -31.90948,
    longitude: 115.806544,
    radius: -1,
    serviceType: 'SL1',
  },
  {
    locationId: 631,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Fenway Subiaco',
    address: '328 Barker Road, SUBIACO WA 6008, Australia',
    latitude: -31.9486,
    longitude: 115.8234,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 632,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Peninsula Mandurah',
    address: '1 Marco Polo Drive, MANDURAH WA 6210, Australia',
    latitude: -32.5284,
    longitude: 115.7173,
    radius: 50,
    serviceType: 'SL3',
  },
  {
    locationId: 633,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Sporting Globe Bar & Grill',
    address: 'cnr Siren Street and Contest Parade, ROCKINGHAM WA 6168, Australia',
    latitude: -32.2884,
    longitude: 115.7483,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 635,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Rambla Bar and Bistro',
    address: 'Unit Lot 780 Carse Street, WICKHAM WA 6720, Australia',
    latitude: -20.6776,
    longitude: 117.1406,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 636,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Morley',
    address: '250 Walter Road, MORLEY WA 6062, Australia',
    latitude: -31.8955,
    longitude: 115.8969,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 637,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Hale Road Tavern',
    address: '64 Hale Road, FORRESTFIELD WA 6058, Australia',
    latitude: -31.9885,
    longitude: 116.0095,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 638,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Federal Boutique Hotel',
    address: '23 William Street, FREMANTLE WA 6160, Australia',
    latitude: -32.0548,
    longitude: 115.7479,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 639,
    venueId: 'TAB',
    openingType: 'On Course',
    name: 'Esperance Bay Turf Club',
    address: 'Unit Lot 202 Fisheries Road, ESPERANCE WA 6450, Australia',
    latitude: -33.8181,
    longitude: 121.9279,
    radius: 160,
    serviceType: 'SL5',
  },
  {
    locationId: 641,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Broken Hill Hotel',
    address: '314 Albany Highway, VICTORIA PARK WA 6100, Australia',
    latitude: -31.9725,
    longitude: 115.8962,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 643,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Haynes Bar & Grill ',
    address: '131 Eighth Street, ARMADALE WA 6112, Australia',
    latitude: -32.148,
    longitude: 115.985,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 644,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Inglewood Hotel',
    address: '803 Beaufort Street, INGLEWOOD WA 6052, Australia',
    latitude: -31.925054,
    longitude: 115.880782,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 645,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Firkin',
    address: 'Unit Shop 39-44 1 Kingfisher Avenue, BALLAJURA WA 6066, Australia',
    latitude: -31.8393,
    longitude: 115.8959,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 646,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Dale Bar & Bistro',
    address: '229 Jull Street, ARMADALE WA 6112, Australia',
    latitude: -32.1526,
    longitude: 116.0139,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 649,
    venueId: 'TAB',
    openingType: 'Full Time',
    name: 'Burswood (Stadium)',
    address: '333 Victoria Park Drive, BURSWOOD WA 6100, Australia',
    latitude: -31.9516,
    longitude: 115.8878,
    radius: 25,
    serviceType: 'SL1',
  },
  {
    locationId: 650,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Sporting Globe Bar & Grill',
    address: 'Unit Shop R-008 330 Pinjarra Road, MANDURAH WA 6210, Australia',
    latitude: -32.5362,
    longitude: 115.7415,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 651,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Burswood',
    address: 'Victoria Park Drive, BURSWOOD WA 6100, Australia',
    latitude: -31.95124,
    longitude: 115.88901,
    radius: -1,
    serviceType: 'SL4',
  },
  {
    locationId: 660,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Sporting Globe Bar & Grill',
    address: 'Unit Belmont Forum Shop FB001 Belmont Avenue, CLOVERDALE WA 6105, Australia',
    latitude: -31.9667,
    longitude: 115.9349,
    radius: 20,
    serviceType: 'SL3',
  },
  {
    locationId: 664,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Hollow Beach Bar and Grill',
    address: '135 Ocean Drive, BUNBURY WA 6230, Australia',
    latitude: -33.3362,
    longitude: 115.6265,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 665,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Sporting Globe Bar & Grill',
    address: 'Unit Cnr The Boulevard and Howtree Place, FLOREAT WA 6014, Australia',
    latitude: -31.9366,
    longitude: 115.7926,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 666,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Quarie Bar & Brasserie',
    address: '2 Macquarie Boulevard, HAMMOND PARK WA 6164, Australia',
    latitude: -32.1603,
    longitude: 115.846,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 667,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Vale Bar & Brasserie',
    address: '281 Beeliar Drive, YANGEBUP WA 6164, Australia',
    latitude: -32.127,
    longitude: 115.7969,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 668,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Cut Tavern Bar & Bistro',
    address: '8 Rod Court, WANNANUP WA 6210, Australia',
    latitude: -32.6045,
    longitude: 115.6409,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 669,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Riverton Bar & Grill',
    address: 'Unit Shop FF1 14-Feb Willeri Drive, PARKWOOD WA 6147, Australia',
    latitude: -32.0391,
    longitude: 115.9062,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 671,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Harvey Bowling Club',
    address: 'Cnr Young and Roy Street, HARVEY WA 6220, Australia',
    latitude: -33.0756,
    longitude: 115.8948,
    radius: 75,
    serviceType: 'SL3',
  },
  {
    locationId: 672,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Legends Bar & Bottle Shop',
    address: '6 Hislop Road, ATTADALE WA 6156, Australia',
    latitude: -32.03137,
    longitude: 115.80902,
    radius: 15,
    serviceType: 'SL3',
  },
  {
    locationId: 673,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Dalyellup ',
    address: 'Lot 9039 Portobello Road, DALYELLUP WA 6230, Australia',
    latitude: -33.3996,
    longitude: 115.6338,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 674,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Currambine Bar & Bistro',
    address: '14 Hobsons Gate, CURRAMBINE WA 6028, Australia',
    latitude: -31.7387,
    longitude: 115.7383,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 675,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Treendale Farm Hotel',
    address: '8 The Promenade, AUSTRALIND WA 6233, Australia',
    latitude: -33.2834,
    longitude: 115.7397,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 676,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Deebo Burgers & Beers',
    address: "398 South Street, O'CONNOR WA 6163, Australia",
    latitude: -32.1179,
    longitude: 115.9142,
    radius: 35,
    serviceType: 'SL3',
  },
  {
    locationId: 677,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Hannans Hotel',
    address: '400 Hannan Street, KALGOORLIE WA 6430, Australia',
    latitude: -30.7515,
    longitude: 121.4677,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 678,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Well Tavern & Bistro',
    address: '21 Chiswick Parade, WELLARD WA 6170, Australia',
    latitude: -32.2636,
    longitude: 115.8167,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 679,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Harbour Sports Bar Grill',
    address: 'Shop 141 Secret Harbour Shopping Centre, SECRET HARBOUR WA 6173, Australia',
    latitude: -32.4087,
    longitude: 115.7586,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 680,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Junction Hotel Moora',
    address: '123 Gardiner Street, MOORA WA 6510, Australia',
    latitude: -30.6386,
    longitude: 116.0094,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 681,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Lesmurdie Club',
    address: 'Unit Cnr Lawnbrook and Boronia Road, WALLISTON WA 6076, Australia',
    latitude: -32.0002,
    longitude: 116.0746,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 682,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Tassels Place Bar & Bistro',
    address: '8 Tassels Place, INNALOO WA 6018, Australia',
    latitude: -31.8951,
    longitude: 115.8023,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 684,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'The Bellevue Darling Range Htl',
    address: '49 Great Eastern Highway, BELLEVUE WA 6056, Australia',
    latitude: -31.8955,
    longitude: 116.0325,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 687,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Bassendean Hotel',
    address: '25 Old Perth Road, BASSENDEAN WA 6054, Australia',
    latitude: -31.9044,
    longitude: 115.9483,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 688,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Safety Bay Bowls & Rec Club',
    address: '130 Gloucester Crescent, SHOALWATER WA 6169, Australia',
    latitude: -32.3034,
    longitude: 115.7044,
    radius: 45,
    serviceType: 'SL3',
  },
  {
    locationId: 690,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: '8 Knots Tavern',
    address: '110 Riverside Drive, EAST FREMANTLE WA 6158, Australia',
    latitude: -32.026,
    longitude: 115.7657,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 691,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Valley Tavern',
    address: '3354 Chapman Valley Road, NABAWA WA 6532, Australia',
    latitude: -28.4992,
    longitude: 114.795,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 692,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Wundowie ',
    address: '3381 Great Eastern Highway, WUNDOWIE WA 6560, Australia',
    latitude: -31.8063,
    longitude: 116.3618,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 693,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Leederville Hotel',
    address: '742 Newcastle Street, LEEDERVILLE WA 6007, Australia',
    latitude: -31.9372,
    longitude: 115.8416,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 695,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Miners Rest Motel',
    address: '4 Great Eastern Highway, KALGOORLIE WA 6430, Australia',
    latitude: -30.7649,
    longitude: 121.4506,
    radius: 25,
    serviceType: 'SL3',
  },
  {
    locationId: 696,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: '33 Degrees Esperance',
    address: 'Unit 51 The Esplande, ESPERANCE WA 6450, Australia',
    latitude: -33.8613,
    longitude: 121.8934,
    radius: 40,
    serviceType: 'SL3',
  },
  {
    locationId: 699,
    venueId: 'TAB',
    openingType: 'Pub/Club Tab',
    name: 'Miners Arms Hotel',
    address: '238 Hampton Road, NORTHAMPTON WA 6535, Australia',
    latitude: -28.3486,
    longitude: 114.6318,
    radius: 30,
    serviceType: 'SL3',
  },
  {
    locationId: 790,
    venueId: 'TAB',
    openingType: 'Account Betting Centre',
    name: 'Scan My Bet',
    address: '14 Hasler Road, OSBORNE PARK WA 6017, Australia',
    latitude: 0,
    longitude: 0,
    radius: 25,
    serviceType: 'N/A',
  },
]
